// extracted by mini-css-extract-plugin
export default {"header__container":"ListHeader_header__container__zqD4m","total__wrap":"ListHeader_total__wrap__ud-6n","-total":"ListHeader_-total__4UBqI","-num":"ListHeader_-num__bicD+"};